document.addEventListener("DOMContentLoaded", function(){
  const bundle_variables = document.querySelector('.js-bundle-variables');
  const bundle_view_info = document.querySelectorAll('.js-bundle-view-info');
  const gs_swatch_buttons = document.querySelectorAll('.js-bundle-variant-button');
  const bundle_add = document.querySelectorAll('.js-bundle-add');
  const bundle_flyout = document.querySelector('.js-bundle-flyout');
  const bundle_flyout_products = document.querySelector('.js-bundle-flyout-products');
  const bundle_flyout_toggle = document.querySelector('.js-bundle-flyout-toggle');
  const bundle_flyout_message = document.querySelector('.js-bundle-flyout-message');
  const bundle_flyout_size = document.querySelector('.js-bundle-flyout-size');
  const bundle_flyout_add = document.querySelector('.js-bundle-flyout-add');
  const bundle_popup_content = document.querySelector('.js-bundle-popup-content');
  
  // Bundle object
  window.luv_aj = window.luv_aj || {};
  window.luv_aj.bundle = {};
  window.luv_aj.bundle.size = parseInt(bundle_variables.dataset.bundleSize);
  window.luv_aj.bundle.items = [];

  // Toggle show hide bundle flyout
  bundle_flyout_toggle.addEventListener('click', (e) => {
    bundle_flyout.classList.toggle('bundle-flyout--minimized');
  });

  // bundle_view_info
  const bundle_popup = document.querySelector('.js-bundle-popup');
  const bundle_popup_overlay = document.querySelector('.js-bundle-popup-overlay');
  const bundle_popup_close = document.querySelector('.js-bundle-popup-close');
  const open_bundle_popup = function() {
    let scrollHeight = window.scrollY;

    window.bundlePopupScroll = scrollHeight;
    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.position = 'absolute';
    document.documentElement.style.inset = '0px';
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'absolute';
    document.body.style.height = 'unset';
    document.body.style.inset = `-${scrollHeight}px 0px 0px`;
    bundle_popup.style.display = 'block';
    window.requestAnimationFrame(() => {
      bundle_popup.style.opacity = '1';
    });
  };
  const close_bundle_popup = function() {
    let scrollHeight = window.bundlePopupScroll || 0;

    bundle_popup.addEventListener('transitionend', () => {
      bundle_popup.style.display = '';
    }, {once: true});

    document.documentElement.style.overflow = '';
    document.documentElement.style.position = '';
    document.documentElement.style.inset = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.height = '';
    document.body.style.inset = '';
    window.scrollBy(0, scrollHeight);

    window.requestAnimationFrame(() => {
      bundle_popup.style.opacity = '0';
    });
    // bundle_popup.style.display = '';
  };
  
  bundle_popup_close.addEventListener('click', close_bundle_popup);
  bundle_popup_overlay.addEventListener('click', close_bundle_popup);
  
  bundle_view_info.forEach((button) => {
    button.addEventListener('click', (e) => {

      bundle_popup_content.innerHTML = '';

      var headers = JSON.parse(
        JSON.stringify({
          credentials: 'same-origin',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-Type': 'text/html;'
          }
        })
      );
      var request = {
        method: 'GET',
        headers: headers
      };
      fetch(button.dataset.url, request)
      .then((response) => {
        if (!response.ok) {
          throw Error(response.statusText);
        }
        // console.log('response',response);
        return response.text();
      })
      .then((data) => {
        // console.log('data', data);
        var parser = new DOMParser();
        var page = parser.parseFromString(data, 'text/html');
        let product_section = page.getElementById('main-content');
        bundle_popup_content.append(product_section);
        bundle_popup_content.scrollTop = 0;
        initPopup();
        open_bundle_popup();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    });
  });

  // Change between gold and silver variants
  gs_swatch_buttons.forEach((button) => {
    button.addEventListener('click', (e) => {
      let parent = button.closest('.js-bundle-product');

      parent.classList.remove('bundle-product--gold');
      parent.classList.remove('bundle-product--silver');
      parent.classList.add('bundle-product--' + button.dataset.variantColor);
      parent.setAttribute('data-variant-id', button.dataset.variantId);
    });
  });

  // Add to bundle
  bundle_add.forEach((button) => {
    button.addEventListener('click', (e) => {
      if (window.luv_aj.bundle.items.length < window.luv_aj.bundle.size) {
        let parent = button.closest('.js-bundle-product');
        let variant_id = parseInt(parent.dataset.variantId);
        let product_data = JSON.parse(parent.dataset.productJson);
        let variant_data = product_data.variants.filter((variant) => { return variant.id === variant_id })[0];
        let item = {
          product: product_data,
          variant: variant_data
        };
  
        window.luv_aj.bundle.items.push(item);

        let current_index = window.luv_aj.bundle.items.length - 1;
        let bundle_product = document.createElement('DIV');
        let image = item.product.featured_image;

        if (item.variant.featured_image) {
          image = item.variant.featured_image.src;
        }

        bundle_product.classList.add('js-bundle-flyout-product','bundle-flyout__product')
        bundle_product.innerHTML = `
          <div class="flex flex-col justify-between items-center h-full gap-2">
            <div>
              <img
              src="${image}&width=400"
              width="200"
              alt="${item.variant.name}"
              data-pin-no-hover="true"
              loading="lazy"
              data-pin-no-hover="true"
              class="block w-full object-cover aspect-4/5" />
              <p class="pt-2 uppercase leading-snug">${item.variant.name}</p>
            </div>
            <button class="js-bundle-remove bundle-remove" type="button">Remove</button>
          </div>
        `;

        bundle_flyout_products.append(bundle_product);

        let remove_buttons = document.querySelectorAll('.js-bundle-remove');
        remove_buttons[current_index].addEventListener('click', (e) => {
          let this_product = e.target.closest('.js-bundle-flyout-product');
          let flyout_products = Array.from(document.querySelectorAll('.js-bundle-flyout-product'));
          let current_index = flyout_products.indexOf(this_product);
          bundle_flyout_products.removeChild(this_product);

          // console.log('remove item', 'current index: ' + current_index);

          window.luv_aj.bundle.items = window.luv_aj.bundle.items.filter((bundle_item) => {
            return bundle_item !== window.luv_aj.bundle.items[current_index];
          });

          // Hide Flyout if 0 products in bundle
          if (window.luv_aj.bundle.items.length === 0) {
            bundle_flyout.classList.add('bundle-flyout--hidden');
          }

          // Hide Add To Cart
          bundle_flyout_add.classList.add('bundle-flyout__add--hidden');
          // Show Message
          bundle_flyout_size.textContent = window.luv_aj.bundle.size - window.luv_aj.bundle.items.length;
          bundle_flyout_message.classList.remove('bundle-flyout__message--hidden');
        });

        // show flyout
        bundle_flyout.classList.remove('bundle-flyout--hidden');
        bundle_flyout.classList.remove('bundle-flyout--minimized');

        // Show Add To Cart
        if (window.luv_aj.bundle.items.length === window.luv_aj.bundle.size) {
          bundle_flyout_add.classList.remove('bundle-flyout__add--hidden');
          bundle_flyout_message.classList.add('bundle-flyout__message--hidden');
        } else {
          bundle_flyout_size.textContent = window.luv_aj.bundle.size - window.luv_aj.bundle.items.length;
        }

      } else {
        alert('Your bundle is full, please remove a product if you want to add another.');
      }
    });
  });

  bundle_flyout_add.addEventListener('click', (e) => {
    let items = [];
    let bundle_number = Math.floor(Math.random() * 1000000);

    if (bundle_variables.dataset.bundleBox) {
      items.push({
        'id': parseInt(bundle_variables.dataset.bundleBox),
        'quantity': 1,
        properties: {
          '_bundle': bundle_number
        }
      });
    }

    window.luv_aj.bundle.items.forEach((bundle_item) => {
      let item = {
        'id': bundle_item.variant.id,
        'quantity': 1,
        properties: {
          '_bundle': bundle_number
        }
      };
      items.push(item);
    });


    let formData = {
      'items': items
    };

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(response => {
      if(response.ok) {
        return response.json();
      }
    })
    .then(response => {
      // console.log('response',response);
      Shopify.theme.cart.getState().then(state => {
        // console.log('getState',state);

        bundle_flyout.classList.add('bundle-flyout--hidden');
        bundle_flyout_add.classList.add('bundle-flyout__add--hidden');
        bundle_flyout_products.innerHTML = '';
        window.luv_aj.bundle.items = [];

        Shopify.theme.cart.rebuildCart(state);
        Shopify.theme.cart.gwpUpdate(state);

        document.body.classList.add("cart--open", "prevent-scroll");
      });
    })
    .catch((error) => {
      console.error('Error:', error);
      alert('One of the items is no longer available, please refresh the page and try making another bundle');
    });
  });

  function initPopup() {
    if (!isDekstop()) {
      // console.log('mobile slider');
      // Product Mobile Slider
      
      const product_image_slider_gold = document.querySelector('.js-bundle-popup .js-product-images-gold');
      const product_image_slider_silver = document.querySelector('.js-bundle-popup .js-product-images-silver');
      const product_image_slider = document.querySelector('.js-bundle-popup .js-product-slider');

      if (product_image_slider_gold || product_image_slider_silver) {
        // console.log('mobile slider gs');
        if (product_image_slider_gold.childElementCount > 1) {
          let flkty = new Flickity( product_image_slider_gold, {
            // options
            imagesLoaded: true,
            cellAlign: 'center',
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            on: {
              ready: function() {
                window.dispatchEvent(new Event('resize'));
                product_image_slider_gold.classList.remove('product-slider--hidden');
              }
            }
          });
        } else {
          product_image_slider_gold.classList.remove('product-slider--hidden');
        }

        if (product_image_slider_silver.childElementCount > 1) {
          let flkty = new Flickity( product_image_slider_silver, {
            // options
            imagesLoaded: true,
            cellAlign: 'center',
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            on: {
              ready: function() {
                window.dispatchEvent(new Event('resize'));
                product_image_slider_silver.classList.remove('product-slider--hidden');
              }
            }
          });
        } else {
          product_image_slider_silver.classList.remove('product-slider--hidden');
        }
      } else {
        // console.log('mobile slider singleton');
        if (product_image_slider.childElementCount > 1) {
          let flkty = new Flickity( product_image_slider, {
            // options
            imagesLoaded: true,
            cellAlign: 'center',
            pageDots: true,
            prevNextButtons: false,
            wrapAround: true,
            on: {
              ready: function() {
                window.dispatchEvent(new Event('resize'));
                product_image_slider.classList.remove('product-slider--hidden');
              }
            }
          });
        } else {
          product_image_slider.classList.remove('product-slider--hidden');
        }
      }
    }
    if (document.querySelector('.js-bundle-popup .js-product-gold-silver-selector')) {
      let gold_silver_buttons = document.querySelectorAll('.js-bundle-popup .js-product-gold-silver-selector');
      const image_sliders = document.querySelectorAll('.js-bundle-popup .js-product-slider');
  
      gold_silver_buttons.forEach((button) => {
        button.addEventListener('click', (e) => {
          gold_silver_buttons.forEach((button) => {
            button.classList.remove('product-gold-silver-selector--selected');
          });
          button.classList.add('product-gold-silver-selector--selected');
          
          let selected_color = button.dataset.color.toLowerCase();
          let selected_slider = document.querySelector('.js-bundle-popup .js-product-images-' + selected_color);
  
          if (!isDekstop()) {
            if (selected_color === 'gold') {
              selected_slider.style.minHeight = document.querySelector('.js-bundle-popup .js-product-images-silver').getBoundingClientRect().height + 'px';
            } else {
              selected_slider.style.minHeight = document.querySelector('.js-bundle-popup .js-product-images-gold').getBoundingClientRect().height + 'px';
            }
          }
  
          image_sliders.forEach((elem) => {
            elem.classList.remove('product-images-gs--active');
          });
  
          selected_slider.classList.add('product-images-gs--active');

          if (!isDekstop()) {
            Flickity.data(selected_slider).select(0);
            window.dispatchEvent(new Event('resize'));
    
            setTimeout(() => {
              selected_slider.style.minHeight = '';
            }, 200);
          }
        });
      });
    }
    
    // Safari video load/play hack
    document.querySelectorAll('.js-product-slide video').forEach((video) => { video.load() });

    $(function(){
      $(".js-bundle-popup .accordion_tab").click(function(){
        $(this).parent().toggleClass("active");
        $(this).toggleClass("active");
        if($(this).hasClass("active")) {
          $(this).attr('aria-expanded', 'true');
          $(".js-bundle-popup .accordion_tab").not(this).parent().removeClass("active");
          $(".js-bundle-popup .accordion_tab").not(this).removeClass("active");
          $(".js-bundle-popup .accordion_tab").not(this).attr('aria-expanded', 'false');
        } else {
          $(this).attr('aria-expanded', 'false');
        }
      })
    })
  }
  function isDekstop() {
    var e = window, 
        a = 'inner';
    if (!('innerWidth' in window )) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    if ( e[ a+'Width' ] >= 768 ) {
      return  true;
    } else {
      return false;
    }
  }
});